import { createContext, useState } from "react";

export const CategoryCollectionContext = createContext();

export const CategoryCollectionContextProvider = ({ children }) => {
    const [selectedCategoryCollections, setSelectedCategoryCollections] = useState([]);

    const contextValue = {
        selectedCategoryCollections,
        setSelectedCategoryCollections
    };

    return (
        <CategoryCollectionContext.Provider value={ contextValue }>
            { children }
        </CategoryCollectionContext.Provider>
    );
}
